<template>
  <div class="button-panel" style="margin-top: 1rem;" @click="$emit('click')">
    <div class="button-panel-head">
      <div class="button-panel-head-line">
        <slot name="headline" />
      </div>
      <div class="button-panel-action">
        <font-awesome-icon icon="chevron-right" class="button-icon" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonPanel',
};
</script>

<style scoped lang="scss">
.button-panel {
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 20px;

  &-head {
    height: 68px;
    display: flex;
    align-items: center;
    position: relative;

    &-line {
      font-size: 1.25rem;
      margin-left: 27px;
      color: #454f63;
    }
  }

  &-action {
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    border: 1px solid #1db2d1;
    position: absolute;
    top: 24px;
    right: 20px;
    color: #1db2d1;
    font-size: 11px;
  }
}
</style>
